/**
 * @file roles.ts
 * @description Definición de constantes y tipos de roles del sistema IEEG.
 *              Úsalo para evitar strings mágicos en servicios, plantillas y guards.
 */

/**
 * @typedef Role
 * @description Tipo unión que representa los roles soportados por la aplicación.
 */
export type Role =
  | 'Administrador'
  | 'Presidencia'
  | 'Secretaria_Ejecutiva'
  | 'Consejero'
  | 'Titular'
  | 'Secretaria_Oficina'
  | 'Archivo'
  | 'Empleado'
  | 'Oficialia_De_Partes'
  | 'Solo_Lectura';

/**
 * @constant ROLES
 * @description Constantes de roles, útiles para importar y usar en el código.
 * @example
 * import { ROLES } from '@/shared/types/roles';
 * this.authService.hasRole(ROLES.Administrador);
 */
export const ROLES = {
  Administrador: 'Administrador',
  Presidencia: 'Presidencia',
  Secretaria_Ejecutiva: 'Secretaria_Ejecutiva',
  Consejero: 'Consejero',
  Titular: 'Titular',
  Secretaria_Oficina: 'Secretaria_Oficina',
  Archivo: 'Archivo',
  Empleado: 'Empleado',
  Oficialia_De_Partes: 'Oficialia_De_Partes',
  Solo_Lectura: 'Solo_Lectura',
} as const;

/**
 * @typedef RoleKey
 * @description Llaves disponibles del objeto ROLES.
 */
export type RoleKey = keyof typeof ROLES;

/**
 * @typedef RoleValue
 * @description Valores de roles tomados del objeto ROLES.
 */
export type RoleValue = (typeof ROLES)[RoleKey];
